const { default: axiosIns } = require('@/libs/axios')

const NotificationsService = {
  // GET - NotificationApiController
  async getNotifications(page, accountId) {
    return axiosIns.get(`/notifications?accountId=${accountId}`, {
      params: {
        page,
      },
    }).then(response => response.data)
  },
  // PATCH - NotificationApiController
  async readAllNotifications(accountId) {
    return axiosIns.patch(`/notifications?accountId=${accountId}`).then(response => response.data)
  },
  async updateNotification(id, status, accountId) {
    return axiosIns.patch(`/notifications/${id}?status=${status}&accountId=${accountId}`).then(response => response.data)
  },
  // DELETE - NotificationApiController
  async deleteNotifcation(id, accountId) {
    return axiosIns.delete(`/notifications/${id}?accountId=${accountId}`).then(response => response.data)
  },
}

export default NotificationsService
